const CART_KEY = "cartProducts";

export const cartStorage = {
  get() {
    const data = localStorage.getItem(CART_KEY);
    if (!data) return null;
    return JSON.parse(data);
  },

  set(cart) {
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
  },

  clear() {
    localStorage.clear(CART_KEY);
    // localStorage.removeItem(CART_KEY);
  },
};
